// REA-CI/screens/LoginScreen.tsx

import React, { useState } from "react";
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  Image,
  ImageBackground,
} from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import { RootStackParamList, StackNavigationProp } from "../navigation/types";

// Type the navigation prop to specify valid screen names
type LoginScreenNavigationProp = StackNavigationProp<RootStackParamList, "LoginScreen">;

const LoginScreen = () => {
  const navigation = useNavigation<LoginScreenNavigationProp>(); // Use the correct navigation type
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = () => {
    console.log("Login with:", email, password);
    navigation.navigate("EligibilityScreen"); // Example of navigation to another screen
  };

  return (
    <ImageBackground
      source={require("../assets/background/4.png")}
      style={styles.background}
    >
      <View style={styles.container}>
        <Image source={require("../assets/logo.png")} style={styles.logo} />

        <Text style={styles.title}>Login</Text>

        <TextInput
          style={styles.input}
          placeholder="Username/Email"
          value={email}
          onChangeText={setEmail}
          autoCapitalize="none"
          keyboardType="email-address"
          placeholderTextColor="#ffffff"
        />
        <TextInput
          style={styles.input}
          placeholder="Password"
          value={password}
          onChangeText={setPassword}
          secureTextEntry
          placeholderTextColor="#ffffff"
        />

        <TouchableOpacity style={styles.button} onPress={handleLogin}>
          <Text style={styles.buttonText}>Login</Text>
        </TouchableOpacity>

        <TouchableOpacity onPress={() => navigation.navigate("SignUpScreen")}>
          <Text style={styles.link}>Sign Up</Text>
        </TouchableOpacity>

        <TouchableOpacity onPress={() => navigation.navigate("ResetPasswordScreen")}>
          <Text style={styles.link}>Forgot Password?</Text>
        </TouchableOpacity>

        {/* Google and Apple login buttons */}
        <View style={styles.socialButtonsContainer}>
          <TouchableOpacity
            onPress={() => console.log("Login with Google")}
            style={styles.googleButton}
          >
            <View style={styles.iconTextContainer}>
              <FontAwesome name="google" size={20} color="#EA4335" style={styles.icon} />
              <Text style={styles.googleButtonText}>Login with Google</Text>
            </View>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => console.log("Login with Apple")}
            style={styles.appleButton}
          >
            <View style={styles.iconTextContainer}>
              <FontAwesome name="apple" size={20} color="#ffffff" style={styles.icon} />
              <Text style={styles.appleButtonText}>Login with Apple</Text>
            </View>
          </TouchableOpacity>
        </View>

        <Text style={styles.disclaimer}>
          By signing up, you accept REA's{" "}
          <Text
            style={styles.linkText}
            onPress={() => navigation.navigate("TermsOfService")}
          >
            Terms of Service
          </Text>
          , and you acknowledge that you have read our{" "}
          <Text
            style={styles.linkText}
            onPress={() => navigation.navigate("PrivacyPolicy")}
          >
            Privacy Policy
          </Text>
          , and{" "}
          <Text
            style={styles.linkText}
            onPress={() => navigation.navigate("CookiePolicy")}
          >
            Cookie Policy
          </Text>
          .
        </Text>
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
    resizeMode: "cover",
  },
  container: {
    flex: 1,
    justifyContent: "center",
    padding: 20,
    backgroundColor: "transparent",
  },
  logo: {
    width: 150,
    height: 150,
    alignSelf: "center",
    marginBottom: 20,
  },
  title: {
    fontSize: 30,
    fontFamily: "Aventra-Bold",
    marginBottom: 20,
    textAlign: "center",
    color: "#ffffff",
  },
  input: {
    height: 50,
    borderColor: "#ddd",
    borderWidth: 1,
    borderRadius: 5,
    marginBottom: 15,
    paddingLeft: 15,
    fontSize: 16,
    fontFamily: "Aventra-Bold",
    color: "#ffffff",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
  },
  button: {
    backgroundColor: "#007BFF",
    paddingVertical: 15,
    borderRadius: 5,
    marginTop: 10,
  },
  buttonText: {
    textAlign: "center",
    color: "#ffffff",
    fontFamily: "Aventra-Bold",
    fontSize: 16,
  },
  link: {
    color: "#ffffff",
    textAlign: "center",
    marginTop: 10,
    fontSize: 16,
    fontFamily: "Aventra-Bold",
  },
  socialButtonsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 15,
  },
  googleButton: {
    flex: 1,
    paddingVertical: 15,
    borderRadius: 5,
    borderColor: "#ddd",
    borderWidth: 1,
    backgroundColor: "#ffffff",
    marginRight: 10,
  },
  appleButton: {
    flex: 1,
    paddingVertical: 15,
    borderRadius: 5,
    borderColor: "#ddd",
    borderWidth: 1,
    backgroundColor: "#000000",
    marginLeft: 10,
  },
  iconTextContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    marginRight: 10,
  },
  googleButtonText: {
    textAlign: "center",
    color: "#333",
    fontFamily: "Aventra-Bold",
  },
  appleButtonText: {
    textAlign: "center",
    color: "#ffffff",
    fontFamily: "Aventra-Bold",
  },
  disclaimer: {
    marginTop: 20,
    fontSize: 12,
    color: "#ffffff",
    textAlign: "center",
    fontFamily: "Aventra-Bold",
  },
  linkText: {
    color: "#007BFF",
    fontFamily: "Aventra-Bold",
  },
});

export default LoginScreen;
